import AppState from '../../../js/AppState';

import Button from '@/components/shared/Button/Button';
import Chapter from '@/js/Chapter';
import clsx from 'clsx';
import { FaCheck, FaLock } from 'react-icons/fa6';
import SoundPlayer from 'react-sdk/SoundPlayer';
import Texts from 'react-sdk/Texts';
import classes from './Module.module.css';

import star_bronze from "./star_bronze.png"
import star_silver from "./star_silver.png"
import star_gold from "./star_gold.png"
import { randomRange } from 'react-sdk/utils';

/**
 *
 * @param {{chapter : Chapter, locked : boolean, prevChapter : Chapter}} param0
 * @returns
 */
const Module = ({chapter, locked, prevChapter, inProgress}) => {

  let finished = chapter.finished
  let scoreThreshold = -1
  let starsMax = chapter.maxStars
  if (finished) {
    if (chapter.stars >= chapter.starsThreshold3)
      scoreThreshold = 3
    else if (chapter.stars >= chapter.starsThreshold2)
      scoreThreshold = 2
    else if (chapter.stars >= chapter.starsThreshold1)
      scoreThreshold = 1
    else
      scoreThreshold = 0
  }

  // finished = true
  // scoreThreshold = Math.floor(randomRange(0, 4))

  function handleClick() {
    if (!locked) {
      SoundPlayer.playSound("Level-selected")
      AppState.launchChapter(chapter)
    }
  }


  if (AppState.allPlayable)
    locked = false

  let playable = AppState.allPlayable || prevChapter == null || prevChapter.finished

  return (
    <div className={clsx(classes.Module, locked && classes.locked)} >


      <div className={classes.image_ctnr}>

        <div className={classes.image} style={{backgroundImage: `url(${chapter.image})`}}></div>

        {finished &&
        <div className={classes.image_finished_overlay} >
          <FaCheck/> Terminé
        </div>}

      </div>

      <div className={classes.footer}>
        <h1 className={classes.title}>{chapter.name}</h1>

        <div className={classes.description} dangerouslySetInnerHTML={{__html: chapter.description  }} />

        {!finished &&
        <div className={classes.btn}>
          {locked ?
          <Button
          onClick={handleClick}
          variant='contour'
          className={classes.btn_locked}
          icon_left={<FaLock />} >
            {chapter.unlockDateText}
          </Button>
          :
          playable ?
          <Button
          onClick={handleClick}
          >
            {inProgress ? Texts.get("chapter-btn-continue") : Texts.get("chapter-btn-play")}
          </Button>
          :
          <Button
          variant='contour'
          className={classes.btn_locked}
          icon_left={<FaLock />} >
            Finir {prevChapter.name} d'abord
          </Button>}

        </div>}


        {finished &&
        <div className={clsx(classes.score_obtained, classes["threshold_"+scoreThreshold])} >
          <div className={classes.stars_count}>
            <span>Etoiles</span>
            <strong>{chapter.stars}/{starsMax}</strong>
          </div>
          {scoreThreshold > 0 &&
          <div className={classes.medal}>
            {scoreThreshold === 1 && <img src={star_bronze} />}
            {scoreThreshold === 2 && <img src={star_silver} />}
            {scoreThreshold === 3 && <img src={star_gold} />}
          </div>}
          {scoreThreshold === 0 &&
          <div className={classes.separator}></div>}
          <div className={classes.level}>
            <span>Niveau</span>
            <strong>{Texts.get("levelname-" + scoreThreshold)}</strong>
          </div>
        </div>
        }

      </div>
    </div>
  );

};

export default  Module